export const singularize = (word: string): string => {
	// Handle common plural forms
	if (word.toLowerCase().endsWith('ies')) {
		// e.g., "Categories" -> "Category"
		return word.slice(0, -3) + 'y';
	} else if (
		word.toLowerCase().endsWith('sses') ||
		word.toLowerCase().endsWith('xes') ||
		word.toLowerCase().endsWith('ches') ||
		word.toLowerCase().endsWith('shes')
	) {
		// e.g., "Classes" -> "Class"
		return word.slice(0, -2);
	} else if (word.toLowerCase().endsWith('s')) {
		// e.g., "Students" -> "Student"
		return word.slice(0, -1);
	}
	return word;
};
